/**
 * c-toc.js — 記事本文の h2 / h3 から目次を自動生成する
 *
 * 記事本文は article.content（管理画面のリッチテキスト）なので、
 * 執筆者に目次を手書きさせない。見出しを書けば勝手に出る。
 *
 * 対象: .article-template__content 内の h2 / h3
 * 出力: <nav class="c-toc"> の中に入れ子リスト
 */
(function () {
  'use strict';

  function slugify(text, index) {
    var base = text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
    return base ? base + '-' + index : 'section-' + index;
  }

  function buildToc() {
    var container = document.querySelector('[data-c-toc]');
    if (!container) return;

    var content = document.querySelector('.article-template__content');
    if (!content) return;

    var headings = content.querySelectorAll('h2, h3');
    if (headings.length < 3) {
      // 見出しが2つ以下の記事に目次は不要
      container.remove();
      return;
    }

    var list = document.createElement('ol');
    list.className = 'c-toc__list';

    Array.prototype.forEach.call(headings, function (heading, i) {
      if (!heading.id) {
        heading.id = slugify(heading.textContent, i);
      }

      var item = document.createElement('li');
      item.className = 'c-toc__item c-toc__item--' + heading.tagName.toLowerCase();

      var link = document.createElement('a');
      link.className = 'c-toc__link';
      link.href = '#' + heading.id;
      link.textContent = heading.textContent;

      item.appendChild(link);
      list.appendChild(item);
    });

    container.appendChild(list);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildToc);
  } else {
    buildToc();
  }
})();
